/* eslint-disable no-undef */
import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getIcon } from '../../Components/Functions';
import { routers } from '../../Constants/routers';
import { login } from '../../Redux/User/actions';
import Api from '../../Server/Api';
import AuthLayout from './AuthLayout'

const api = new Api();

export const PasswordReset = (props) => {
  
  
  const { secret, pin } = useParams();

	const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState();

	const [data, setData] = React.useState({});




	const _login = async () => {
		if (!data?.new_password || !data?.confirm_password) {
			notyf.open({
				type: "error",
				message: "Please enter all fields to reset password.",
			});
			return;
		}
		if (!(data?.new_password  === data?.confirm_password)) {
			notyf.open({
				type: "error",
				message: "Password confirmation does not match.",
			});
			return;
		}
		setLoading(true);
		const res = await api.post({ endpoint: `/users/${secret}/reset_password/`, data: { ...data, pin } });
		if (res?.status) {
      props?.changeViewToSuccess()
		} else {
      let time = 5
      setMessage(res?.detail || res?.message || "Unknown error message.")
      const interval = setInterval(() => {
        if(time < 1) {
          clearInterval(interval);
          setMessage();
        }
        time--;
      }, 1000);
		}
		setLoading(false);
	};


    
    return (
        <div className="form-card">
        <form>
        <div id="signin-form" className="login-form">
        {message && (
								<div
									className={`message is-${"danger"}`}
								>
									<div
										class="message-body"
										dangerouslySetInnerHTML={{ __html: message }}
									/>
								</div>
							)}

          {/* Input */}
          <div className="field">
            <div className="control">
              <h3>Hello, <b>{props?.data?.name || props?.data?.email}</b></h3>
              <p>You can now reset your password.</p>
            </div>
          </div>
    
          {/* Input */}
          <div className="field">
         
            <div className="control has-icon">
              <input 
                className="input" type="password" placeholder="Password"
                onInput={(e) =>
                    setData({ ...data, new_password: e.target.value })
                } />
              <span className="form-icon" dangerouslySetInnerHTML={{ __html: getIcon("lock") }} />
            </div>
          </div>
          {/* Input */}
          <div className="field">
         
            <div className="control has-icon">
              <input 
                className="input" type="password" placeholder="Password"
                onInput={(e) =>
                    setData({ ...data, confirm_password: e.target.value })
                } />
              <span className="form-icon" dangerouslySetInnerHTML={{ __html: getIcon("lock") }} />
            </div>
          </div>
        
          {/* Submit */}
          <div className="control login">
            <button type="button" className={`button h-button is-primary is-bold is-fullwidth is-raised ${loading ? "is-loading" : ""}`}
                onClick={() => _login()}
            >
              Change Password
            </button>
          </div>
        </div>
      </form>
      </div>
    )
}


const PasswordResetConfirm = (props) => {
  const { secret, pin } = useParams();
	const [loading, setLoading] = React.useState(false);

	const [data, setData] = React.useState({});

  const init = async () => {
    setLoading(true);
    const res = await api.get({ endpoint: `/users/${secret}/password_reset_confirm/`, data: { pin }});
    setData(res);
    setLoading(false);
  }

    React.useEffect(()=>{ init(); }, [])


    if(loading){
      return (
        <>
        <div id="pageloader" className="pageloader is-left-to-right is-active" />
        <div id="infraloader" className="infraloader is-active" />
        </>
      )
    }

    return (
        <AuthLayout>
          {data?.data?.email ? (
            <PasswordReset {...props} data={data?.data||{}} changeViewToSuccess={() => {
              setData({
                data: null,
                title: "Password Reset",
                detail: "You have successfully reset your password, you may now continue to login."
              })

            }}/>
          ): (
            <div className="columns is-vcentered">
                <div className="column is-12">
                <div className="card card-form careers-card-form" style={{ background: "rgba(255,255,255,0.75)" }}>
                    <div className="hero-text">
                    <h1 className="title is-3 is-bold text-primary">{data?.title || "Invalid Link"}</h1>
                    <p className="subtitle is-left ">
                        {data?.detail}
                    </p>
                    <div className="buttons">
                        <a href={routers.auth.login}  className="button is-primary is-raised-hover mx-1">Login Now</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
          )}
        </AuthLayout>
    )
}


const mapStateToProps = ({ user }) => {
	return { user };
};

const mapDispatchToProps = (dispatch) => {
	return { login: (e) => dispatch(login(e)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetConfirm);